import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ initialSeconds = 900, onExpire, className = '' }) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (seconds <= 0) {
      setIsExpired(true);
      if (onExpire) {
        onExpire();
      }
      return;
    }

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds, onExpire]);

  const formatTime = (totalSeconds) => {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getColorClass = () => {
    if (isExpired) return 'text-red-600';
    if (seconds < 60) return 'text-orange-600';
    if (seconds < 300) return 'text-yellow-600';
    return 'text-emerald-600';
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg 
        className={`w-5 h-5 ${getColorClass()}`} 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
        />
      </svg>
      <span className={`text-sm font-semibold ${getColorClass()}`}>
        {isExpired ? 'Expired' : `Expires in ${formatTime(seconds)}`}
      </span>
    </div>
  );
};

export default CountdownTimer;
